import { type FC, useState } from 'react';

import { useCountLines } from '../../utils/hooks/useCountLines';

interface BioProps {
  bio: string;
  maxLines?: number;
  className?: string;
  readMoreButtonClassName?: string;
}

export const Bio: FC<BioProps> = ({
  bio,
  className,
  readMoreButtonClassName,
  maxLines = 4,
}) => {
  const [bioLines, bioRef] = useCountLines();

  const [expandedBio, setExpandedBio] = useState(false);

  return (
    <div className={className}>
      <p
        ref={bioRef}
        className={`whitespace-pre-line break-words font-normal ${
          !expandedBio && bioLines >= maxLines && 'line-clamp-4'
        }`}
      >
        {bio}
      </p>
      {bioLines > maxLines ? (
        <button
          className={`link link--primary mt-0.5 text-lg font-medium ${readMoreButtonClassName}`}
          onClick={() => setExpandedBio((prevState) => !prevState)}
        >
          {expandedBio ? 'Read less' : 'Read more'}
        </button>
      ) : null}
    </div>
  );
};
